import type { Directive, DirectiveBinding } from 'vue'

interface ClickOutSideElement extends HTMLElement {
  clickOutside?: (event: Event) => void
}

function mounted(el: ClickOutSideElement, binding: DirectiveBinding<() => void>) {
  const callback = binding.value
  const handleClick = (event: Event) => {
    if (el && !el.contains(event.target as any) && !event.defaultPrevented) {
      if (typeof callback === 'function') {
        callback()
      }
    }
  }
  el.clickOutside = handleClick
  document.addEventListener('click', el.clickOutside, true)
  return true
}

function unmounted(el: ClickOutSideElement) {
  if (el.clickOutside) {
    document.removeEventListener('click', el.clickOutside, true)
  }
  delete el.clickOutside
  return true
}

function updated(el: ClickOutSideElement, binding: DirectiveBinding<() => void>) {
  if (binding.value !== binding.oldValue) {
    unmounted(el)
    mounted(el, binding)
  }
  return true
}

const clickOutside: Directive<ClickOutSideElement, () => void> = {
  mounted,
  updated,
  unmounted,
}

export default clickOutside
